import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useMoveOrganizationalUnit } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { OrganizationalUnitSelection } from "./organizationalUnitSelection";
import { Props, Destination } from "./types";
import styles from "./styles.scss";

function OrganizationalUnitMove({ organizationalUnit, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, moveOrganizationalUnit } =
    useMoveOrganizationalUnit();
  const [destination, setDestination] = useState<Destination>(null);

  return (
    <Modal
      header={t("moveOrganizationalUnit.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.body}>
          <OrganizationalUnitSelection
            sourceOrganizationalUnit={organizationalUnit}
            destination={destination}
            placeholder={t("moveOrganizationalUnit.placeholder")}
            select={setDestination}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("moveOrganizationalUnit.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            press={() =>
              destination !== null &&
              moveOrganizationalUnit({
                organizationalUnit,
                newParentUuid:
                  destination === "root" ? undefined : destination.uuid,
              })
            }
          >
            {t("moveOrganizationalUnit.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { OrganizationalUnitMove };
